module.exports = __webpack_public_path__ + "static/media/award03.73a36a9e.png";